import useSWR from 'swr'
import { session } from 'auth/session'
import { apiClient } from '../api'

export const useOrgs = () => {
  const userName = session?.get('user')?.userName
  /**
   * Fetch my orgs
   */
  const { data: orgs, error } = useSWR(userName && `core/tenants`, (url) =>
    apiClient({
      url,
      params: {
        userName: userName,
      },
    })
  )
  const isLoadingOrgs = !orgs && !error

  return {
    orgs,
    isLoadingOrgs,
    errorOrgs: error,
  }
}
